/**
 * Display label for a stored link: hostname only, so long paths stay out of the row.
 * mailto and tel have no hostname, so the address or number is shown instead.
 * Unparseable values are returned unchanged; the row truncates them.
 */
export function formatLinkHost(storedUrl: string): string {
  try {
    const parsed = new URL(storedUrl);
    if (parsed.protocol === "mailto:" || parsed.protocol === "tel:") {
      const value = schemeSpecificValue(parsed).toLowerCase();
      return value || storedUrl;
    }

    const hostname = parsed.hostname.replace(/^www\./, "").toLowerCase();
    return hostname || storedUrl;
  } catch {
    return storedUrl;
  }
}

function schemeSpecificValue(parsed: URL): string {
  const raw = parsed.pathname.replace(/^\/+/, "");
  try {
    return decodeURIComponent(raw);
  } catch {
    return raw;
  }
}
